import { Component, HostListener } from '@angular/core';
import { PromptService } from './main/layout/prompt/prompt.service';
import { ImageService } from './shared/services/image.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private promptSrv: PromptService, public imgService: ImageService) {}

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Pass the event so it can be triggered later.
    this.promptSrv.openPromptComponent("android", e);
  }

  /*** Commented due to new cache strategies in service-worker.js (workbox) ***/
  // //Update client if there's a new version
  // updateClient() {
  //   if (!this.swUpdate.isEnabled) {
  //     return;
  //   }

  //   //This event will trigger if there's a new version available (this event will trigger after page load and every time after checkForUpdates)
  //   this.swUpdate.available.subscribe(event => {
  //     this.swUpdate.activateUpdate().then(() => location.reload());
  //   });
  // }

  // //Check for software updates every X time (depending on the environment)
  // checkUpdates() {
  //   this.appRef.isStable.subscribe((isStable) => {
  //     if (isStable) {
  //       const timeInterval = interval(this.configurationSvc.configuration.checkForUpdatesInterval);

  //       timeInterval.subscribe(() => {
  //         this.swUpdate.checkForUpdate();
  //       });
  //     }
  //   });
  // }

}
